import React,{ useEffect, useRef } from "react";

const IFrameContainer = ({ content, stylesheets }) => {

    const iframe = useRef();




    /**
     * Updates the iframes content and inserts stylesheets.
     * TODO: Currently stylesheets are just added for proof of concept. Implement
     * and algorithm which updates the stylesheets properly.
     */
    useEffect(() => {
        const updateIframe = () => {

            const document = iframe.current.contentDocument;
            const head = document.getElementsByTagName('head')[0];
            document.body.innerHTML = content;

            stylesheets && stylesheets.forEach(url => {
                const ref = document.createElement('link');
                ref.rel = 'stylesheet';
                ref.type = 'text/css';
                ref.href = url;
                head.appendChild(ref);
            });
        };
        updateIframe()
    }, [content,stylesheets]);

    return <iframe title="Message" ref={iframe} style={{width:'100%', height: '500px'}}/>

}
export default IFrameContainer;